<template>
  <div>
    <div class="row mt-2 g-3">
      <div class="col-12 col-lg-4">
        <div class="px-3 pt-3 shadow rounded-1">
          <div class="d-flex align-items-center">
            <span class="widget-icon me-3" style="height: auto">
              <i class="fa fa-user text-primary" />
            </span>
            <h3 class="m-0">Sudah Penilaian Teknis</h3>
          </div>
          <p class="fs-1">{{ dataPenerbitan.sudah_pentek }}</p>
          <div class="row g-0 pb-3">
            <div
              role="button"
              class="col-6"
              @click="toggleDetailPenerbitanDiterimaPenilaianTeknis(true)"
            >
              <h5 class="m-0">{{ dataPenerbitan.diterima_pentek }}</h5>
              <p class="text-secondary m-lg-0">Diterima</p>
            </div>
            <div
              role="button"
              class="col-6"
              @click="toggleDetailPenerbitanDitolakPenilaianTeknis(true)"
            >
              <h5 class="m-0">{{ dataPenerbitan.ditolak_pentek }}</h5>
              <p class="text-secondary m-lg-0">Ditolak</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-4">
        <div class="h-auto shadow rounded-1 p-3">
          <div
            role="button"
            class="d-flex flex-column justify-content-between"
            style="height: 100%"
            @click="toggleDetailPenerbitanMenungguPembayaran(true)"
          >
            <div class="d-flex align-items-center">
              <span class="widget-icon me-3" style="height: auto">
                <i class="fa fa-hourglass-half text-primary" />
              </span>
              <h3 class="m-0">Menunggu Pembayaran PNBP</h3>
            </div>
            <p class="fs-1 m-0">
              {{ dataPenerbitan.belum_bayar_pnbp }}
            </p>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-4">
        <div class="h-auto shadow rounded-1 p-3">
          <div
            role="button"
            class="d-flex flex-column justify-content-between"
            style="height: 100%"
            @click="toggleDetailPenerbitanSudahBayar(true)"
          >
            <div class="d-flex align-items-center">
              <span class="widget-icon me-3" style="height: auto">
                <i class="fa fa-check-square text-primary" />
              </span>
              <h3 class="m-0">
                Sudah Bayar BNBP <br />
                (Belum Terbit)
              </h3>
            </div>
            <p class="fs-1 m-0">
              {{ dataPenerbitan.sudah_bayar_pnbp }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-2 g-3">
      <div class="col-12 col-lg-6">
        <div class="px-3 pt-3 shadow rounded-1">
          <div class="d-flex align-items-center">
            <span class="widget-icon me-3" style="height: auto">
              <i class="fa fa-id-card-o text-primary" />
            </span>
            <h3 class="m-0">Jumlah Penerbitan Izin</h3>
          </div>
          <p class="fs-1">{{ dataPenerbitan.izin_terbit }}</p>
          <div class="row g-0 pb-3">
            <div
              role="button"
              class="col-6 col-lg-3"
              @click="toggleDetailPenerbitanPersetujuan(true)"
            >
              <h5 class="m-0">{{ dataPenerbitan.izin_persetujuan }}</h5>
              <p class="text-secondary m-lg-0">Persetujuan</p>
            </div>
            <div
              role="button"
              class="col-6 col-lg-3"
              @click="toggleDetailPenerbitanKonfirmasi(true)"
            >
              <h5 class="m-0">{{ dataPenerbitan.izin_konfirmasi }}</h5>
              <p class="text-secondary m-lg-0">Konfirmasi</p>
            </div>
            <div
              role="button"
              class="col-6 col-lg-3 border-left ps-2"
              @click="toggleDetailPenerbitanBerusaha(true)"
            >
              <h5 class="m-0">{{ dataPenerbitan.izin_berusaha }}</h5>
              <p class="text-secondary m-0">Berusaha</p>
            </div>
            <div
              role="button"
              class="col-6 col-lg-3 ps-2"
              @click="toggleDetailPenerbitanNonberusaha(true)"
            >
              <h5 class="m-0">{{ dataPenerbitan.izin_nonberusaha }}</h5>
              <p class="text-secondary m-0">Nonberusaha</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6">
        <div
          class="h-auto shadow rounded-1 p-3 d-flex flex-column justify-content-between"
        >
          <div class="d-flex justify-content-between">
            <div class="d-flex align-items-center">
              <span class="widget-icon me-3" style="height: auto">
                <i class="fa fa-money text-primary" />
              </span>
              <h3 class="m-0">Capaian PNBP</h3>
            </div>
            <div class="d-flex align-items-center">
              <div class="flex-shrink-0 me-2">Sampai dengan Bulan -</div>
              <div>
                <select
                  :value="filter_bulan"
                  id="filter_bulan_pnbp"
                  class="form-select"
                  @change="emitFilterBulan($event.target.value)"
                >
                  <option v-for="(d, i) in optionBulan" :value="i + 1">
                    {{ d }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <p class="fs-1 m-0">
            {{ formatIDR(dataPenerbitan.capaian_pnbp) }}
          </p>
        </div>
      </div>
    </div>

    <DetailPenerbitanDiterimaPenilaianTeknis
      :show="showDetailPenerbitanDiterimaPenilaianTeknis"
      @close="toggleDetailPenerbitanDiterimaPenilaianTeknis"
      :filter-tahun="filterTahun"
    />
    <DetailPenerbitanDitolakPenilaianTeknis
      :show="showDetailPenerbitanDitolakPenilaianTeknis"
      @close="toggleDetailPenerbitanDitolakPenilaianTeknis"
      :filter-tahun="filterTahun"
    />
    <DetailPenerbitanMenungguPembayaran
      :show="showDetailPenerbitanMenungguPembayaran"
      @close="toggleDetailPenerbitanMenungguPembayaran"
      :filter-tahun="filterTahun"
    />
    <DetailPenerbitanSudahBayar
      :show="showDetailPenerbitanSudahBayar"
      @close="toggleDetailPenerbitanSudahBayar"
      :filter-tahun="filterTahun"
    />
    <DetailPenerbitanPersetujuan
      :show="showDetailPenerbitanPersetujuan"
      @close="toggleDetailPenerbitanPersetujuan"
      :filter-tahun="filterTahun"
    />
    <DetailPenerbitanKonfirmasi
      :show="showDetailPenerbitanKonfirmasi"
      @close="toggleDetailPenerbitanKonfirmasi"
      :filter-tahun="filterTahun"
    />
    <DetailPenerbitanBerusaha
      :show="showDetailPenerbitanBerusaha"
      @close="toggleDetailPenerbitanBerusaha"
      :filter-tahun="filterTahun"
    />
    <DetailPenerbitanNonberusaha
      :show="showDetailPenerbitanNonberusaha"
      @close="toggleDetailPenerbitanNonberusaha"
      :filter-tahun="filterTahun"
    />
  </div>
</template>

<script>
import { formatIDR } from '../../../../helper/helpernew'
import DetailPenerbitanBerusaha from '../DetailDashboard/DetailPenerbitanBerusaha.vue'
import DetailPenerbitanDiterimaPenilaianTeknis from '../DetailDashboard/DetailPenerbitanDiterimaPenilaianTeknis/DetailPenerbitanDiterimaPenilaianTeknis.vue'
import DetailPenerbitanDitolakPenilaianTeknis from '../DetailDashboard/DetailPenerbitanDitolakPenilaianTeknis/DetailPenerbitanDitolakPenilaianTeknis.vue'
import DetailPenerbitanKonfirmasi from '../DetailDashboard/DetailPenerbitanKonfirmasi/DetailPenerbitanKonfirmasi.vue'
import DetailPenerbitanMenungguPembayaran from '../DetailDashboard/DetailPenerbitanMenungguPembayaran/DetailPenerbitanMenungguPembayaran.vue'
import DetailPenerbitanNonberusaha from '../DetailDashboard/DetailPenerbitanNonberusaha.vue'
import DetailPenerbitanPersetujuan from '../DetailDashboard/DetailPenerbitanPersetujuan/DetailPenerbitanPersetujuan.vue'
import DetailPenerbitanSudahBayar from '../DetailDashboard/DetailPenerbitanSudahBayar/DetailPenerbitanSudahBayar.vue'

const option_bulan = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'Mei',
  'Jun',
  'Jul',
  'Agu',
  'Sep',
  'Okt',
  'Nov',
  'Des',
]

export default {
  components: {
    DetailPenerbitanDiterimaPenilaianTeknis,
    DetailPenerbitanDitolakPenilaianTeknis,
    DetailPenerbitanMenungguPembayaran,
    DetailPenerbitanSudahBayar,
    DetailPenerbitanPersetujuan,
    DetailPenerbitanKonfirmasi,
    DetailPenerbitanBerusaha,
    DetailPenerbitanNonberusaha,
  },
  props: ['dataPenerbitan', 'filter_bulan', 'filterTahun'],
  data() {
    return {
      optionBulan: [...option_bulan],

      showDetailPenerbitanDiterimaPenilaianTeknis: false,
      showDetailPenerbitanDitolakPenilaianTeknis: false,
      showDetailPenerbitanMenungguPembayaran: false,
      showDetailPenerbitanSudahBayar: false,
      showDetailPenerbitanPersetujuan: false,
      showDetailPenerbitanKonfirmasi: false,
      showDetailPenerbitanBerusaha: false,
      showDetailPenerbitanNonberusaha: false,
    }
  },
  methods: {
    formatIDR,

    emitFilterBulan(val) {
      this.$emit('update:filter_bulan', val)
    },

    toggleDetailPenerbitanDiterimaPenilaianTeknis(val) {
      this.showDetailPenerbitanDiterimaPenilaianTeknis = val
    },
    toggleDetailPenerbitanDitolakPenilaianTeknis(val) {
      this.showDetailPenerbitanDitolakPenilaianTeknis = val
    },
    toggleDetailPenerbitanMenungguPembayaran(val) {
      this.showDetailPenerbitanMenungguPembayaran = val
    },
    toggleDetailPenerbitanSudahBayar(val) {
      this.showDetailPenerbitanSudahBayar = val
    },
    toggleDetailPenerbitanPersetujuan(val) {
      this.showDetailPenerbitanPersetujuan = val
    },
    toggleDetailPenerbitanKonfirmasi(val) {
      this.showDetailPenerbitanKonfirmasi = val
    },
    toggleDetailPenerbitanBerusaha(val) {
      this.showDetailPenerbitanBerusaha = val
    },
    toggleDetailPenerbitanNonberusaha(val) {
      this.showDetailPenerbitanNonberusaha = val
    },
  },
}
</script>

<style scoped>
.h-auto {
  height: auto !important;
}

@media (min-width: 1200px) {
  .h-auto {
    height: 100% !important;
  }
}
</style>
